/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderDTO } from '../models/OrderDTO';
import type { OrderDTOODataListResponse } from '../models/OrderDTOODataListResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OrderService {

    /**
     * @param clientId 
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns OrderDTOODataListResponse Success
     * @throws ApiError
     */
    public static getBackendv2Order(
clientId?: number,
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<OrderDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/order',
            query: {
                'clientId': clientId,
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns OrderDTO Success
     * @throws ApiError
     */
    public static postBackendv2Order(
requestBody?: OrderDTO,
): CancelablePromise<OrderDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/backendv2/order',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteBackendv2Order(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/backendv2/order',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @returns OrderDTO Success
     * @throws ApiError
     */
    public static getBackendv2Order1(
key: number,
): CancelablePromise<OrderDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/backendv2/order/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @returns OrderDTO Success
     * @throws ApiError
     */
    public static putBackendv2OrderPlace(
key: number,
): CancelablePromise<OrderDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/backendv2/order/{key}/place',
            path: {
                'key': key,
            },
        });
    }

}
